import MenuContainer from './MenuContainer';
import MenuItem from './MenuItem';

const MenuOptions = {
  Container: MenuContainer,
  Item: MenuItem
};

export default MenuOptions;
